var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('p',{attrs:{"id":"title-text"}},[_vm._v("cycler")]),_c('v-progress-circular',{attrs:{"size":40,"indeterminate":"","width":4,"id":"loading-bar","color":"#ffffff"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }